import { render } from "./lidaForm.vue?vue&type=template&id=ac213b1a"
import script from "./lidaForm.vue?vue&type=script&lang=js"
export * from "./lidaForm.vue?vue&type=script&lang=js"

import "./lidaForm.vue?vue&type=style&index=0&id=ac213b1a&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__